import { Box } from '@mui/material'
import { memo } from 'react'

import { DepositContent } from './DepositContent'

export const DepositMobile = memo(() => {
  return (
    <Box sx={{ pt: 2 }}>
      <DepositContent />
    </Box>
  )
})
